import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';

import {
  Container,
  NavigationScroll,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, Menu } from '@uncinc/react-drupal-core';

import LogoSvg from '../../../assets/images/dgb-logo.svg';
import { NODE_TYPE_ANNUAL_REPORT_LANDING_PAGE, SCREEN_TABLET } from '../../../config/constants';

import '../style.scss';

const MIN_BREADCRUMB_LEVEL = 3;

const BackButton = ({ title, url }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const translation = useMemo(() => {
    if (width < SCREEN_TABLET) {
      return t('general.back');
    }

    const breadcrumbs = url.split('/').slice(1);

    return t('general.back_to', {
      destination: breadcrumbs.length < MIN_BREADCRUMB_LEVEL ? t('annual_report.annual_report').toLocaleLowerCase() : title,
    });
  }, [t, title, url, width]);

  return (
    <CoreLink className="Header__menu__back" to={url}>
      <i className="icon icon-arrow-left icon-variant-0" />
      <span>{translation}</span>
    </CoreLink>
  );
};

const AnnualReportHeader = () => {
  const previousBreadcrumb = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const nodeType = state.getIn(['node', entityId, 'type', 0, 'target_id']);

    if (nodeType === NODE_TYPE_ANNUAL_REPORT_LANDING_PAGE) {
      return;
    }

    const breadcrumbs = state.getIn(['entity', 'breadcrumbs'], Immutable.List());
    return breadcrumbs.get(breadcrumbs.size - 1, Immutable.Map()).toJS();
  });

  return (
    <header className="Header--AnnualReportHeader">
      <NavigationScroll>
        <Container className="Header__container">
          <div className="row">
            <div className="Header__logo col-2">
              <Menu id="annual-report-navigation">
                {(items) => items.map((item) => {
                  if (item) {
                    const url = item.getIn(['link', 'url'], '');

                    return (
                      <CoreLink key={url} to={url}>
                        <img
                          className="Header__logo__img"
                          src={LogoSvg}
                          alt="De Regenboog Groep logo"
                        />
                      </CoreLink>
                    );
                  }
                })}
              </Menu>
            </div>

            {(previousBreadcrumb && Object.keys(previousBreadcrumb).length > 0) && (
              <div className="Header__menu col-10">
                <BackButton {...previousBreadcrumb} />
              </div>
            )}
          </div>
        </Container>
      </NavigationScroll>
    </header>

  );
};

export default AnnualReportHeader;
